// crear plantilla defualt 
export default {
    name: 'gestion_usuarios',
    data() {
        return {
            listaUsuarios: [],
            headerUsuarios: [
                { text: 'NIT', value: 'usuario.nit', sortable: true },
                { text: 'CUI', value: 'usuario.cui', sortable: true },
                { text: 'Primer nombre', value: 'usuario.primer_nombre', sortable: true },
                { text: 'Segundo nombre', value: 'usuario.segundo_nombre', sortable: true },
                { text: 'Primer apellido', value: 'usuario.primer_apellido', sortable: true },
                { text: 'Segundo apellido', value: 'usuario.segundo_apellido', sortable: true },
                { text: 'Fecha de nacimiento', value: 'usuario.fecha_nacimiento', sortable: true },
                { text: 'Estado', value: 'deleted_at', sortable: true },
                { text: 'acciones', value: 'accion', sortable: false },
            ],
            cargando: false,
            buscar: "",
            dialogUsuario: false,

            editarUsuarioInfo: {
                id: "",
                deleted_at: "",
                usuario: {
                    nit: "",
                    cui: "",
                    primer_nombre: "",
                    segundo_nombre: "",
                    primer_apellido: "",
                    segundo_apellido: "",
                    fecha_nacimiento: "",
                    deleted_at: ""
                }
            },

            campoRules: [
                v => !!v || 'El campo es requerido',
            ],

            campoRulesCui: [
                v => !!v || 'El campo es requerido',
                v => (v && v.length == 13) || 'El campo debe tener 13 caracteres',
                v => /^[0-9]*$/.test(v) || 'El campo debe ser numerico'
            ],

            // campo fecha de nacimiento mm/dd/yyyy
            campoRulesFecha: [
                v => !!v || 'El campo es requerido',
                v => (v && v.length == 10) || 'El campo debe tener 10 caracteres',
                v => (v && v[2] == "/" && v[5] == "/") || 'El campo debe tener el formato mm/dd/yyyy'
            ],

            esCambiandoContrasena: false,

            cambiarContrasenaInfo: {
                password_banca: "",
                usuario_id: "",
            },
        }
    },

    async created() {
        console.log("gestion de usuarios");
        await this.listadoUsuarios();
    },

    methods: {

        cambiarContrasena() {
            console.log("cambiar contraseña");
            this.esCambiandoContrasena = true;
        },

        async actualizarInfoClienteGestor() {
            try {
                this.cargando = true;
                let body = {
                    usuario_id: this.editarUsuarioInfo.usuario_id,
                    password_banca: this.editarUsuarioInfo.usuario.password_sat,
                };
                console.log("actualizar info cliente gestor", body);


                let r = await this.$store.state.services.gestoresService.actualizarInfoClienteGestor(body);
                console.log("actualizar info sat cliente", r);
                if (r.data.success) {
                    this.$toast.success("Información del cliente actualizada correctamente");
                    this.dialogUsuario = false;
                    this.esCambiandoContrasena = false;
                    await this.listadoUsuarios();
                } else {
                    this.$toast.error("Error al actualizar la información del cliente");
                }
            } catch (error) {
                console.log(error);
                this.$toast.error("Error al actualizar la información del cliente");
            } finally {
                this.cargando = false;
            }
        },

        async listadoUsuarios() {
            try {
                this.cargando = true;
                let r = await this.$store.state.services.gestoresService.listadoUsuarios();
                console.log(r);
                if (r.data.data != null) {
                    this.listaUsuarios = r.data.data;
                }
            } catch (error) {
                console.log(error);
                this.$toast.error("Error al cargar los usuarios del gestor");
            } finally {
                this.cargando = false;
            }
        },


        editarUsuario(item) {
            console.log("editar", item);
            this.dialogUsuario = true;
            // igualar el objeto
            this.editarUsuarioInfo = Object.assign({}, item);
        },

        inhabilitarUsuario(item) {
            console.log("eliminar", item);
            this.editarUsuarioInfo.deleted_at = true;
        },

        habilitarUsuario(item) {
            console.log("habilitar", item);
            this.editarUsuarioInfo.deleted_at = null;
        },

        cancelarDialog() {
            console.log("cancelar");
            this.dialogUsuario = false;
        },

        async aceptarDialog() {
            console.log("aceptar");
            try {
                this.cargando = true;
                let r = await this.$store.state.services.gestoresService.modificarInformacionUsuario(this.editarUsuarioInfo);
                console.log(r);
                if (r.data.success) {
                    this.$toast.success("Usuario modificado correctamente");
                    this.dialogUsuario = false;
                    await this.listadoUsuarios();
                } else {
                    this.$toast.error("Error al modificar el usuario");
                }

            } catch (error) {
                console.log(error);
                this.$toast.error("Error al modificar el usuario");
            } finally {
                this.cargando = false;
            }
        }
    },

    watch: {
    },

    computed: {
    }

};